<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">Users Management</h1>
    <app-navpath class="hidden md:block" />
  </div>
  <div class="mb-2 flex w-full flex-col gap-1 md:w-fit md:flex-row">
    <button
      class="shorter-btn misc-btn"
      [routerLink]="[
        '../user-management',
        '00000000-0000-0000-0000-000000000000'
      ]"
    >
      <fa-icon [icon]="faPlus" class="mr-1"></fa-icon>Add User
    </button>
    <app-search-input
      (dataOutput)="onSearch($event)"
      [isTable]="true"
      class="block w-full md:w-auto"
    ></app-search-input>
  </div>
  <div class="content-container">
    <div class="w-full overflow-x-auto">
      <app-data-table
        class="block min-w-[44rem]"
        (edit)="editEntry($event)"
        (remove)="removeEntry($event)"
        (open)="openEntry($event)"
        [tableHeaders]="tableHeaders"
        [tableEntries]="filteredUsers"
      ></app-data-table>
    </div>
  </div>
</section>
